import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";
import { searchLoader } from "./pages/search/searchLoader";
import detailsLoader from "./pages/details/detailsLoader";
import { homeLoader } from "./pages/home/homeLoader";
import ErrorPage from "./pages/ErrorPage";
import { LoadingProvider } from "./context/LoadingContext";
import { Loader } from "./components/Loader";
// Import the Root component directly
import Root from "./pages/Root";

// Shared route-level loading fallback for lazy route components
function RouteLoadingSkeleton() {
  return (
    <div className="flex items-center justify-center gap-4 p-8">
      <Loader size="medium" />
      <p className="text-zinc-600">Loading content...</p>
    </div>
  );
}

// Lazy load route components, but use direct import for Root
const HomePage = lazy(() => import("./pages/home/HomePage"));
const SearchPage = lazy(() => import("./pages/search/SearchPage"));
const DetailsPage = lazy(() => import("./pages/details/DetailsPage"));

// Create the router with better metadata and error handling
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />, // Use directly imported Root
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<RouteLoadingSkeleton />}>
            <HomePage />
          </Suspense>
        ),
        loader: homeLoader,
        handle: {
          title: "NPM Registry - Search and Explore Packages",
        },
      },
      {
        path: "/search",
        element: (
          <Suspense fallback={<RouteLoadingSkeleton />}>
            <SearchPage />
          </Suspense>
        ),
        loader: searchLoader,
        handle: {
          title: "Search Results - NPM Registry",
        },
        errorElement: <ErrorPage />, // Add dedicated error boundary
      },
      {
        path: "/packages/:name",
        element: (
          <Suspense fallback={<RouteLoadingSkeleton />}>
            <DetailsPage />
          </Suspense>
        ),
        loader: detailsLoader,
        handle: {
          title: "Package Details - NPM Registry",
        },
        errorElement: <ErrorPage />, // Add dedicated error boundary
      },
    ],
  },
]);

function App() {
  return (
    <LoadingProvider initialLoading={false}>
      <RouterProvider router={router} />
    </LoadingProvider>
  );
}

export default App;
